import { Component, OnInit,ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';

@Component({
  selector: 'app-ordermanagement',
  templateUrl: './ordermanagement.component.html',
  styleUrls: ['./ordermanagement.component.css']
})
export class OrdermanagementComponent implements OnInit {
  @ViewChild('TableOnePaginator', { read: MatPaginator }) TableOnePaginator: MatPaginator;
  @ViewChild('TableTwoPaginator', { read: MatPaginator }) TableTwoPaginator: MatPaginator;
  @ViewChild('TableThreePaginator', { read: MatPaginator }) TableThreePaginator: MatPaginator;
  @ViewChild('TableFourPaginator', { read: MatPaginator }) TableFourPaginator: MatPaginator;

  @ViewChild('firstTableSort') firstTableSort: MatSort;
  @ViewChild('secondTableSort') secondTableSort: MatSort;
  @ViewChild('thirdTableSort') thirdTableSort: MatSort;
  @ViewChild('fourthTableSort') fourthTableSort: MatSort;

  dataSource: any;
  dataSourceCompleted:any;
  dataSourceCancelled:any;
  displayedActiveColumns = ['orderId', 'accountDetails.vendorName','userAccountEmailId','orderStatus','productsList']
  displayedCompletedColumns = ['orderId', 'accountDetails.vendorName','userAccountEmailId','orderStatus','productsList']
  displayedCancelledColumns = ['orderId', 'accountDetails.vendorName','userAccountEmailId','orderStatus','productsList']
  dataSourceProductDetails:any
  displayedColumnsProductDetails=['productName','productImage','description','actualPrice','offeredPrice','stockQuantity']
  tableData: any;
  userDetails: any;
  userSessionData: any;
  productImageId: any;
  myurl: string;
  showFilter: boolean;
  showCustomisedSearch: boolean;
  filterValueSelected: string;
  searchValue: string;
  showFilterCompleted: boolean;
  showCustomisedSearchCompleted: boolean;
  filterValueSelectedCompleted: string;
  searchValueCompleted: string;
  showFilterCancelled: boolean;
  searchValueCancelled: string;
  filterValueSelectedCancelled: string;
  showCustomisedSearchCancelled: boolean;

  constructor(private cs:CucurachaAdminService,private excelService: ExcelService) {
    this.myurl = this.cs.endpoint;

   }
   filter(){
    this.getAllAccountsActiveOrders()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForActiveOrders(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data.result)

      })
    }
    else {
      this.getAllAccountsActiveOrders()
    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllAccountsActiveOrders();

  }
  filterForCompletedOrders(){
    this.getAllActiveCompletedorders()
    if (this.showFilterCompleted == false) {
      this.showFilterCompleted = true
      this.showCustomisedSearchCompleted = false
      this.searchValueCompleted=""
      this.filterValueSelectedCompleted=""
    }
    else {
      this.showFilterCompleted = false
      this.showCustomisedSearchCompleted= false
      this.searchValueCompleted=""
      this.filterValueSelectedCompleted=""
    }
  }
  applyCustomizedFilterSearchForCompletedOrders(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForCompletedOrders(this.filterValueSelectedCompleted, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSourceCompleted = new MatTableDataSource(data.result)

      })
    }
    else {
      this.getAllActiveCompletedorders()
    }
  }
  applyCustomizedFilterForCompletedOrders() {
    this.showCustomisedSearchCompleted = true
    this.searchValueCompleted=""
    this.getAllActiveCompletedorders();

  }
  filterForCancelledOrders(){
    this.getAllCancelledOrders()
    if (this.showFilterCancelled == false) {
      this.showFilterCancelled = true
      this.showCustomisedSearchCancelled = false
      this.searchValueCancelled=""
      this.filterValueSelectedCancelled=""
    }
    else {
      this.showFilterCancelled = false
      this.showCustomisedSearchCancelled= false
      this.searchValueCancelled=""
      this.filterValueSelectedCancelled=""
    }
  }
  applyCustomizedFilterSearchForCancelledOrders(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForCancelledOrders(this.filterValueSelectedCancelled, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSourceCancelled = new MatTableDataSource(data.result)

      })
    }
    else {
      this.getAllCancelledOrders()
    }
  }
  applyCustomizedFilterForCancelledOrders() {
    this.showCustomisedSearchCancelled = true
    this.searchValueCancelled=""
    this.getAllCancelledOrders();

  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
    this.dataSourceCancelled.filter = filterValue;
    this.dataSourceCompleted.filter = filterValue;
  }
 
  viewImages(id:any){
    this.productImageId=id
  }
  ngOnInit(): void {
    this.getAllCancelledOrders();
    this.getAllActiveCompletedorders();
    this.getAllAccountsActiveOrders();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))
    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails=data[0]
    })
  }

  /*****************************get All Accounts Active Orders  ***********************/
  getAllAccountsActiveOrders(){
    this.cs.getAllAccountsActiveOrders().subscribe((data)=>{
      this.dataSource = new MatTableDataSource(data.result);
      this.dataSource.sort = this.firstTableSort;
      this.dataSource.paginator = this.TableOnePaginator;
    });
  }

  /*******************************get All Active Completed orders **********/
  getAllActiveCompletedorders(){
    this.cs.getAllActiveCompletedorders().subscribe((data)=>{
      this.dataSourceCompleted = new MatTableDataSource(data.result);
      this.dataSourceCompleted.sort = this.secondTableSort;
      this.dataSourceCompleted.paginator = this.TableTwoPaginator;
    });
  }
  exportActiveTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'Active-orders');
    this.cs.exportLogAdd(this.userDetails.emailId, 'Active-orders').subscribe((data) => {
    })
  }
  exportCompletedTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSourceCompleted.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'Completed-orders');
    this.cs.exportLogAdd(this.userDetails.emailId, 'Completed-orders').subscribe((data) => {
    })
  }
  exportCancelledTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSourceCancelled.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'Cancelled-orders');
    this.cs.exportLogAdd(this.userDetails.emailId, 'Cancelled-orders').subscribe((data) => {
    })
  }
  /******************************get All Cancelled Orders ******************/
  getAllCancelledOrders(){
    this.cs.getAllCancelledOrders().subscribe((data)=>{
      this.dataSourceCancelled = new MatTableDataSource(data.result);
      this.dataSourceCancelled.sort = this.thirdTableSort;
      this.dataSourceCancelled.paginator = this.TableThreePaginator;
    });
  }
  getProductsDetailsByhistoryId(orderId:any,status:any){
    this.cs.getProductsDetailsByhistoryId(orderId,status).subscribe((data)=>{
      console.log(data.productsList)
      this.dataSourceProductDetails= new MatTableDataSource(data.productsList);
      this.dataSourceProductDetails.sort = this.fourthTableSort;
      this.dataSourceProductDetails.paginator = this.TableFourPaginator;
    });
  }
}
